<template>
  <DxButton v-if="isCabinetsPage"
            class="try-new-version-header-btn"
            text="Try new version"
            styling-mode="outlined"
            @click="goToNewVersion"
  />
</template>

<script setup>
  import { computed } from "vue"
  import { useRoute } from "vue-router"
  import DxButton from "devextreme-vue/button"
  import { redirectToV3, setPreferV3 } from "@/js-modules/preferV3.js"

  const route = useRoute()
  const isCabinetsPage = computed(() => route.name === "cabinets")

  function goToNewVersion() {
    setPreferV3()
    redirectToV3()
  }
</script>

<style scoped lang="scss">
  .try-new-version-header-btn {
    margin: 0 0.35rem;

    :deep(.dx-button-content) {
      padding: 0.35rem 0.75rem !important;
    }

    :deep(.dx-button-text) {
      color: $la-new-bright-yellow !important;
      font-size: 0.875rem !important;
      font-weight: 600 !important;
    }

    :deep(&.dx-button) {
      border-color: $la-new-bright-yellow !important;
      background: transparent !important;
    }

    :deep(&.dx-button:hover),
    :deep(&.dx-button.dx-state-hover) {
      background-color: $blue-opac !important;
    }
  }
</style>
